export const createAction = (type: string) => {
  const actionCreator = (payload?: unknown) => ({ type, payload });
  actionCreator.toString = () => type;
  return actionCreator;
};

export const SEARCH_VACANCIES_REQUESTED = 'SEARCH_VACANCIES_REQUESTED';
export const SEARCH_VACANCIES_RECEIVED = 'SEARCH_VACANCIES_RECEIVED';
export const SEARCH_VACANCIES_REJECTED = 'SEARCH_VACANCIES_REJECTED';

export const OPEN_MOBILE_SEARCH_REQUESTED = 'OPEN_MOBILE_SEARCH_REQUESTED';
export const OPEN_MOBILE_SEARCH_RECEIVED = 'OPEN_MOBILE_SEARCH_RECEIVED';
export const OPEN_MOBILE_SEARCH_REJECTED = 'OPEN_MOBILE_SEARCH_REJECTED';

export const SEARCH_VACANCY_GROUP_REQUESTED = 'SEARCH_VACANCY_GROUP_REQUESTED';
export const SEARCH_VACANCY_GROUP_RECEIVED = 'SEARCH_VACANCY_GROUP_RECEIVED';
export const SEARCH_VACANCY_RECEIVED = 'SEARCH_VACANCY_RECEIVED';
export const SEARCH_VACANCY_REQUESTED = 'SEARCH_VACANCY_REQUESTED';
export const SEARCH_VACANCY_GROUP_REJECTED = 'SEARCH_VACANCY_GROUP_REJECTED';

export const SET_SEARCH_VALUE_REQUESTED = 'SET_SEARCH_VALUE_REQUESTED';
export const SET_SEARCH_VALUE_RECEIVED = 'SET_SEARCH_VALUE_RECEIVED';
export const SET_SEARCH_VALUE_REJECTED = 'SET_SEARCH_VALUE_REJECTED';

export const MAIN_PAGE_REQUESTED = 'MAIN_PAGE_REQUESTED';
export const MAIN_PAGE_RECEIVED = 'MAIN_PAGE_RECEIVED';
export const MAIN_PAGE_REJECTED = 'MAIN_PAGE_REJECTED';

export const OFFICE_PAGE_REQUESTED = 'OFFICE_PAGE_REQUESTED';
export const OFFICE_PAGE_RECEIVED = 'OFFICE_PAGE_RECEIVED';
export const OFFICE_PAGE_REJECTED = 'OFFICE_PAGE_REJECTED';

export const OPERATIONS_PAGE_REQUESTED = 'OPERATIONS_PAGE_REQUESTED';
export const OPERATIONS_PAGE_RECEIVED = 'OPERATIONS_PAGE_RECEIVED';
export const OPERATIONS_PAGE_REJECTED = 'OPERATIONS_PAGE_REJECTED';

export const TECH_PAGE_REQUESTED = 'TECH_PAGE_REQUESTED';
export const TECH_PAGE_RECEIVED = 'TECH_PAGE_RECEIVED';
export const TECH_PAGE_REJECTED = 'TECH_PAGE_REJECTED';

export const GET_NEWS_REQUESTED = 'GET_NEWS_REQUESTED';
export const GET_NEWS_RECEIVED = 'GET_NEWS_RECEIVED';
export const GET_NEWS_REJECTED = 'GET_NEWS_REJECTED';

export const GET_MORE_NEWS_REQUESTED = 'GET_MORE_NEWS_REQUESTED';
export const GET_MORE_NEWS_RECEIVED = 'GET_MORE_NEWS_RECEIVED';
export const GET_MORE_NEWS_REJECTED = 'GET_MORE_NEWS_REJECTED';

export const GET_DIVISION_REQUESTED = 'GET_DIVISION_REQUESTED';
export const GET_DIVISION_RECEIVED = 'GET_DIVISION_RECEIVED';
export const GET_DIVISION_REJECTED = 'GET_DIVISION_REJECTED';

export const requestVacancies = createAction(SEARCH_VACANCIES_REQUESTED);
export const receiveVacancies = createAction(SEARCH_VACANCIES_RECEIVED);
export const rejectVacancies = createAction(SEARCH_VACANCIES_REJECTED);
export const requestMobileSearch = createAction(OPEN_MOBILE_SEARCH_REQUESTED);
export const receiveMobileSearch = createAction(OPEN_MOBILE_SEARCH_RECEIVED);
export const rejectMobileSearch = createAction(OPEN_MOBILE_SEARCH_REJECTED);
export const requestVacancyGroup = createAction(SEARCH_VACANCY_GROUP_REQUESTED);
export const receiveVacancyGroup = createAction(SEARCH_VACANCY_GROUP_RECEIVED);
export const rejectVacancyGroup = createAction(SEARCH_VACANCY_GROUP_REJECTED);
export const requestSearchValue = createAction(SET_SEARCH_VALUE_REQUESTED);
export const receiveSearchValue = createAction(SET_SEARCH_VALUE_RECEIVED);
export const rejectSearchValue = createAction(SET_SEARCH_VALUE_REJECTED);
export const reсeiveSearchVacancy = createAction(SEARCH_VACANCY_RECEIVED);
export const requestSearchVacancy = createAction(SEARCH_VACANCY_REQUESTED);

export const requestMainPage = createAction(MAIN_PAGE_REQUESTED);
export const receiveMainPage = createAction(MAIN_PAGE_RECEIVED);
export const rejectMainPage = createAction(MAIN_PAGE_REJECTED);

export const requestOfficePage = createAction(OFFICE_PAGE_REQUESTED);
export const receiveOfficePage = createAction(OFFICE_PAGE_RECEIVED);
export const rejectOfficePage = createAction(OFFICE_PAGE_REJECTED);

export const requestOperationsPage = createAction(OPERATIONS_PAGE_REQUESTED);
export const receiveOperationsPage = createAction(OPERATIONS_PAGE_RECEIVED);
export const rejectOperationsPage = createAction(OPERATIONS_PAGE_REJECTED);

export const requestTechPage = createAction(TECH_PAGE_REQUESTED);
export const receiveTechPage = createAction(TECH_PAGE_RECEIVED);
export const rejectTechPage = createAction(TECH_PAGE_REJECTED);

export const rejectGetNews = createAction(GET_NEWS_REJECTED);
export const reсeiveGetNews = createAction(GET_NEWS_RECEIVED);
export const requestGetNews = createAction(GET_NEWS_REQUESTED);
export const rejectGetMoreNews = createAction(GET_MORE_NEWS_REJECTED);
export const reсeiveGetMoreNews = createAction(GET_MORE_NEWS_RECEIVED);
export const requestGetMoreNews = createAction(GET_MORE_NEWS_REQUESTED);
export const rejectDivisionNews = createAction(GET_DIVISION_REJECTED);
export const reсeiveDivisionNews = createAction(GET_DIVISION_RECEIVED);
export const requestDivisionNews = createAction(GET_DIVISION_REQUESTED);
